import React from "react";
import { IconsContainerProps, IconContainer } from "components/IconContainer";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

export interface BoxInfoProps extends IconsContainerProps {
  value?: string;
  title?: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      margin: theme.spacing(1),
    },
    iconContainer: {
      display: "flex",
      justifyItems: "center",
      justifyContent: "center",
    },
    containe: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-evenly",
      paddingLeft: 10,
      textTransform: "capitalize",
    },
    title: {
      color: theme.palette.primary.main,
      fontWeight: "bold",
      fontSize: 10,
    },
    value: {
      color: "#707070",
      fontSize: 12,
    },
  })
);
export const BoxInfo = ({
  icon,
  title = "Title",
  value = "value",
  height = 52,
  width = 160,
}: BoxInfoProps) => {
  const styles = useStyles();
  return (
    <div
      className={styles.root}
      style={{
        height,
        width,
      }}
    >
      <div className={styles.iconContainer}>
        <IconContainer icon={icon} />
      </div>
      <div className={styles.containe}>
        <div className={styles.title}>{title}:</div>
        <div className={styles.value}>{value}</div>
      </div>
    </div>
  );
};
